import React from 'react';
import PropTypes from 'prop-types';
import hasAncestor from '../../js/hasAncestor';
import './AddressToolbar.css';

const isOutside = (target) => {
    return !hasAncestor(target, el => el.classList.contains('AddressToolbar-history')) && !hasAncestor(target, el => el.classList.contains('AddressToolbar-history-list'));
};

class AddressToolbar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            address: props.address,
            showHistory: false
        };
    }
    componentWillMount() {
        document.addEventListener('mousedown', this.onOutsideClick);
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.onOutsideClick);
    }
    onSubmit = (e) => {
        e.preventDefault();
        let address = this.state.address;
        if (!/^https?:\/\//.test(address)) {
            address = `http://${address}`;
        }
        window.location = address;
    }
    onInputChange = (e) => {
        this.setState({ address: e.target.value });
    }
    onInputFocus = (e) => {
        e.currentTarget.select();
    }
    onHistoryClick = (e) => {
        e.preventDefault();
        this.setState({ showHistory: !this.state.showHistory });
    }
    onOutsideClick = (e) => {
        if (isOutside(e.target)) {
            this.setState({ showHistory: false });
        }
    }
    render() {
        let history;
        if (this.props.history.length && this.state.showHistory) {
            const items = this.props.history.map((href) => {
                return (
                    <li key={href}>
                        <a href={href}>
                            <span>{href}</span>
                        </a>
                    </li>
                );
            });
            history = <ul className="AddressToolbar-history-list">{items}</ul>;
        }
        return (
            <form className="AddressToolbar" onSubmit={this.onSubmit}>
                <label className="AddressToolbar-label"
                       htmlFor="AddressToolbar-input">Address</label>
                <div className="AddressToolbar-input-wrap">
                    <div className="AddressToolbar-input-bevel_outer">
                        <div className="AddressToolbar-input-bevel_inner">
                            <input className="AddressToolbar-input"
                                   id="AddressToolbar-input"
                                   value={this.state.address}
                                   onChange={this.onInputChange}
                                   onFocus={this.onInputFocus}
                                   spellCheck="false"
                                   autoComplete="off"
                                   type="text" />
                            <button className="AddressToolbar-history"
                                    type="button"
                                    onClick={this.onHistoryClick}>
                                <span className="AddressToolbar-history-border"></span>
                            </button>
                        </div>
                    </div>
                    {history}
                </div>
                <button type="submit" className="AddressToolbar-go">
                    <span>Go</span>
                </button>
            </form>
        );
    }
}

AddressToolbar.propTypes = {
    address: PropTypes.string,
    history: PropTypes.arrayOf(PropTypes.string)
};

AddressToolbar.defaultProps = {
    address: '',
    history: []
};

export default AddressToolbar;



// WEBPACK FOOTER //
// ./src/components/Browser/AddressToolbar.jsx